import { jsx as _jsx } from "react/jsx-runtime";
import toggleIcon from './JCB-ICON-BHL.png';
import './ProductToggleIcon.scss';
export var ProductToggleIcon = function () {
    return _jsx("img", { className: "ProductToggleIcon", src: toggleIcon, "aria-hidden": true });
};
